import React from 'react';
export function usePanel(state, props) {
    var isDisabled = state.isDisabled, isReadonly = state.isReadonly;
    var panel = props.panel;
    var _a = React.useState(false), open = _a[0], setOpen = _a[1];
    var _b = React.useState(false), force = _b[0], setForce = _b[1];
    function show() {
        return Boolean(panel &&
            open &&
            !force &&
            !isDisabled() &&
            !isReadonly());
    }
    function focus() {
        setOpen(true);
    }
    function keydown(event) {
        if (event.key === Keys.Tab) {
            setOpen(false);
        }
    }
    function clickAway() {
        setOpen(false);
    }
    return {
        show: show(),
        close: function () { return setForce(true); },
        open: function () { return setForce(false); },
        onFocus: focus,
        onKeyDown: keydown,
        onClickAway: clickAway,
    };
}
